import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../services/menu.service';
import { RouterService } from '../../services/router.service';
import {IgrPermissionsStructure } from '../Interfaces/igeneralresponse02';
//import { Location } from '@angular/common';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  color: string;
  cols: number;
  rows: number;
  class: string;
  backColor: string;
}

export const ROUTES: RouteInfo[] = [];

@Component({
  selector: 'menu03-data',
  templateUrl: './menu03.component.html',
  animations: [
    trigger('hamburgerX', [
      state('closed', style({ transform: 'rotate(0deg)' })),
      state('open', style({ transform: 'rotate(90deg)' })),
      transition('closed <=> open', animate('200ms ease-in-out'))
    ])
  ]
})


export class Menu03Component {

  constructor(
    private router: Router,
    private menuService: MenuService,
    private securityParams: ActivatedRoute,
    private routerService: RouterService,
    //private location: Location

  ) { }

  menuItems: any[];
  functions: IgrPermissionsStructure[];
  mainFunction: string;
  title: string;
  darkMode = false;

  async ngOnInit() {
    this.mainFunction = (this.securityParams.snapshot.params.functioncode).toString().toUpperCase();
    this.LoadContent();
  }

  LoadContent()
  {
    this.functions =[];
    this.menuItems = [];
    //this.menuService.GetMainMenu(this.mainFunction).subscribe(results => {
    //  if (results.body.isValid) {
    //    this.title = results.body.resultData..description
    //  }
    //  else {
    //    this.title =results.body.error.description;
    //  }
    //});
    this.menuService.GetMainMenu(this.mainFunction).subscribe(results => {
      for (const entry of results.body.resultData) {
        this.addRoutes({
          path: '/', description: entry.description.trim(),
          icon: entry.icon, color: '#A51955', cols: 1, rows: 1, class: '', backColor: '', children:entry.children 
        });
      }
      this.menuItems = this.functions.filter(menuItem => menuItem);
    },
      (e) => {
        console.log(e);
      });
    this.menuItems = this.functions.filter(menuItem => menuItem);
  }

  addRoutes(route) {
    this.functions.push(route);
  }

  b_back() {
    var _Route=this.routerService.getBackRoute();
      this.router.navigate([_Route], { skipLocationChange: true });
    //this.location.back();

  }

  clickMenu(Route, Id) {
    this.routerService.putRoute("menu03/" + this.mainFunction.toLowerCase())
    this.router.navigate([Route], { skipLocationChange: true }) ;
  }

  toggleDarkMode() {
    this.darkMode = !this.darkMode;
  }
}






